import React from 'react';

import { IIconProps, TIconType } from '../interface';

const StarIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			data-testid='star-icon'
			fill='none'
			height='32'
			viewBox='0 0 32 32'
			width='32'
			{...props?.innerSvgProps}
		>
			<path
				d='M16.1632 22.634L20.8882 25.634C21.4976 26.0184 22.2476 25.4465 22.0695 24.7434L20.7007 19.3621C20.6637 19.213 20.6696 19.0564 20.7177 18.9104C20.7658 18.7645 20.8542 18.6351 20.9726 18.5371L25.2101 15.0028C25.7632 14.5434 25.482 13.6153 24.7601 13.5684L19.2289 13.2121C19.0779 13.2034 18.9328 13.1508 18.8113 13.0609C18.6898 12.971 18.597 12.8476 18.5445 12.7059L16.482 7.51213C16.4274 7.36204 16.3279 7.23239 16.1971 7.14077C16.0663 7.04915 15.9104 7 15.7507 7C15.591 7 15.4352 7.04915 15.3044 7.14077C15.1735 7.23239 15.0741 7.36204 15.0195 7.51213L12.957 12.7059C12.9044 12.8476 12.8117 12.971 12.6902 13.0609C12.5686 13.1508 12.4235 13.2034 12.2726 13.2121L6.74135 13.5684C6.01948 13.6153 5.73823 14.5434 6.29135 15.0028L10.5289 18.5371C10.6473 18.6351 10.7357 18.7645 10.7838 18.9104C10.8319 19.0564 10.8377 19.213 10.8007 19.3621L9.5351 24.3496C9.31948 25.1934 10.2195 25.8778 10.9414 25.4184L15.3382 22.634C15.4615 22.5556 15.6046 22.514 15.7507 22.514C15.8968 22.514 16.0399 22.5556 16.1632 22.634V22.634Z'
				fill='currentColor'
				stroke={props?.color ?? '#2E2E6B'}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default StarIcon;
